import { render, staticRenderFns } from "./ReportNameField.vue?vue&type=template&id=2253b8ba&"
import script from "./ReportNameField.vue?vue&type=script&lang=ts&"
export * from "./ReportNameField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports